import { render, staticRenderFns } from "./HistoryArchiveExportSelector.vue?vue&type=template&id=7cdda3b4&"
import script from "./HistoryArchiveExportSelector.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HistoryArchiveExportSelector.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports